<template>
  <b-layout :colors="$site.colors" :header-title="title" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <template v-if="passes && passes.length">
          <pass
            v-for="pass in passes" 
            :key="pass.id"
            :title="pass.name"
            :img="passImage(pass)"
            :info="pass.information ? formatHtml(pass.information) : $t('general.pass')"
            :price="pass.priceLabel"
            :label="$t('pages.pass.index.buyItem',{item: pass.name})"
            @click="selectPass(pass)"
          />
        </template>
      </div>
    </b-container>
  </b-layout>
</template>

<script>
import Utils from '@/utils'

import Pass from '@/components/pass/elements/Pass'

export default defineNuxtComponent({
  components: {
    Pass
  },
  computed: {
    title() {
      return this.$site.tabs.getName('pass', 'Pass')
    },
    homeRoute() {
      return this.$store.getters.homeRoute || { path: '/' }
    }
  },
  async asyncData () {
    const { $api } = useNuxtApp()

    try {
      const response = await $api.pass.passes()

      return {
        passes: response.passes
      }
    } catch (error) {
      return {
        passes: null
      }
    }
  },
  methods: {
    formatHtml(text) {
      return Utils.text.formatHtml(text)
    },
    async selectPass(pass) {
      await this.$store.dispatch('pass/setPassDetails', { pass })

      const urlQuery = this.$store.getters['pass/urlQuery']
      this.$router.push({ path: '/pass/customer', query: urlQuery })
    },
    passImage(pass) {
      if (pass.images) {
        return pass.images.large
      } else if (this.$site.images.pass) {
        return this.$site.images.pass.large
      }
      return null
    }
  }
})
</script>
